<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <!-- <div class="title">设置兑换密码</div> -->
                <div style="width: 100%; font-size: 16px; color: #666; margin-top: 26vw; text-align: center;">请再次输入密码</div>

                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <input class="input_p" placeholder="6位数字密码" maxlength="6" type="password" v-model="password" />

                <div @click="btnConfirm" class="btn_next">下一步</div>
            </div>
         
        </div>

    </div>
</template>


<script>
import axios from 'axios';
import ProfitHelper from '../ProfitHelper';
import { prefix, prefix_dev, userBankSetPassword } from '../url';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            password: '',
            user_score: 0.00
        };
    },

    created() {
        this.formatUrlParams();
    },

    methods: {
        back() {
            window.location.href = '/profit-password';
        },

        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');
        },

        btnConfirm() {
            const str = localStorage.getItem('PASSWORD_SET');

            if (this.password != str) {
                alert('两次密码不一致！')
                return;
            }

            const url = this.urlPrefix + userBankSetPassword;
            let params = {
                password: str,
                repassword: this.password
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data == true) {
                    window.location.href = '/profit-account';
                } else {
                    alert(res.data.msg);
                }
            })
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
    flex-direction: column;
}
.title {
    margin-top: 20vw;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 500;
}

.input_p {
    width: 60vw;
    height: 12vw;
    margin-top: 10vw;
    margin-left: 20vw;
    border: 1px #EEE solid;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
}
.btn_next {
    display: flex;
    width: 88vw;
    height: 12vw;
    background: linear-gradient(to right, #CBACFF, #7384FF);
    align-self: center;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: white;
    border-radius: 28px;
    margin-top: 10vw;
}
</style>